import React, { useState } from 'react';
import { Button } from 'react-bootstrap5';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import routes from 'app/routes';
import SummaryView from 'components/ProgramBuilder/Summary';
import { useContext as useTemplatesContext } from 'components/Managers/Templates/Context';
import StepTab from 'components/new_ui/Tabs/StepTab';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { clearStorage } from 'components/ProgramBuilder/Storage';

export default function Summary() {
  const { state } = useLocation();
  const { data, selectedTopics, template } = state || {};
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { dispatch: dispatchTemplates, actions: actionsTemplates } = useTemplatesContext();

  const onSave = () => {
    setLoading(true);
    actionsTemplates.create(dispatchTemplates, data, () => {
      setLoading(false);
      clearStorage();
      navigate(routes.managers.templates.index);
    });
  };

  return (
    <>
      <StepTab total={3} current={3} />

      <div className="content">
        <section>
          <h1>Summary</h1>
        </section>

        <section>
          <SummaryView data={data} />
        </section>

        <footer className="d-flex justify-content-between">
          <Link
            to={routes.managers.templates.orderTopics}
            className="btn btn-outline-primary"
            state={{
              selectedTopics,
              data,
              template,
            }}
          >
            Previous
          </Link>

          <Button
            onClick={onSave}
            disabled={loading}
          >
            {loading && <LoadingPlaceholder placement="inline" />}
            {' '}
            Save
          </Button>
        </footer>
      </div>
    </>
  );
}
